import { memo } from "react";
import { FeaturedIconOutline, FeaturedIconOutlineProps } from "../../../MiscIcons";

import { ReactComponent as InfoIcon } from "./icons/info.svg";
import { ReactComponent as SuccessIcon } from "./icons/success.svg";

type AlertCircleIconProps = Omit<FeaturedIconOutlineProps, "children">;

export const AlertBrandCircleIcon = memo<AlertCircleIconProps>(({ style, ...props }) => {
  return (
    <FeaturedIconOutline {...props} color="brand">
      <InfoIcon />
    </FeaturedIconOutline>
  );
});

export const AlertGrayCircleIcon = memo<AlertCircleIconProps>(({ style, ...props }) => {
  return (
    <FeaturedIconOutline {...props} color="gray">
      <InfoIcon />
    </FeaturedIconOutline>
  );
});

export const AlertErrorCircleIcon = memo<AlertCircleIconProps>(({ style, ...props }) => {
  return (
    <FeaturedIconOutline {...props} color="error">
      <InfoIcon />
    </FeaturedIconOutline>
  );
});

export const AlertWarningCircleIcon = memo<AlertCircleIconProps>(({ style, ...props }) => {
  return (
    <FeaturedIconOutline {...props} color="warning">
      <InfoIcon />
    </FeaturedIconOutline>
  );
});

export const AlertSuccessCircleIcon = memo<AlertCircleIconProps>(({ style, ...props }) => {
  return (
    <FeaturedIconOutline {...props} color="success">
      <SuccessIcon />
    </FeaturedIconOutline>
  );
});